import React from 'react';
import { Button, Modal } from 'rsuite';
import { useTranslation } from 'react-i18next';
import './TimeOffRequestWarning.scss';

const noop = () => { };

/**
 * Component to show the
 * @param {import('rsuite/esm/Overlay/Modal').BaseModalProps {
 *  isOpen: boolean;
 *  onOk: Function;
 * }} param0
 */
const TimeOffRequestWarning = ({
    isOpen = false,
    onOk = noop,
}) => {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'form' });

    return (
        <div className="tor-container">
            <Modal
                open={isOpen}
                style={{ zIndex: 1300 }}
                size="md"
                enforceFocus={false}
                dialogClassName="tor-warning-modal"
            >
                <Modal.Title>{t('warning')}</Modal.Title>
                <Modal.Body className="modal-body">
                    {t('timeOffRequestWarning')}
                </Modal.Body>
                <Modal.Footer >
                    <Button
                        onClick={onOk}
                        appearance="primary"
                    >
                        {t('ok')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default TimeOffRequestWarning;
